import React, { useEffect, useState } from 'react'
import DataLoader from '../DataLoader'
import InsightsTray from '../DataInsights/InsightsTray'
import DataFilters from '../DataFilters/DataFilters'
import { useDataContext } from '../../contexts/DataContext'
import { useChartContext } from '../../contexts/ChartContext'
import { useUIContext } from '../../contexts/UIContext'
import { clearUrlState } from '../../services/urlState'

export default function LoadStep({ actions }) {
  const {
    dataLoader,
    data,
    auditSummary,
    largeDatasetInfo,
    dataFilters,
    setDataFilters,
    filteredData,
    filteredUserData,
    autoRefreshEnabled,
    setAutoRefreshEnabled,
    autoRefreshInterval,
    setAutoRefreshInterval,
    lastRefreshedAt,
    setLastRefreshedAt,
  } = useDataContext()

  const { importProject, applyFixes, charts } = useChartContext()

  const { recommendations, aiResult, handleRecommendationSelect, setShowIntro } =
    useUIContext()

  const [isMobileLayout, setIsMobileLayout] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches
  )

  useEffect(() => {
    if (typeof window === 'undefined') return undefined
    const mq = window.matchMedia('(max-width: 767px)')
    const handleChange = () => setIsMobileLayout(mq.matches)
    if (mq.addEventListener) {
      mq.addEventListener('change', handleChange)
      return () => mq.removeEventListener('change', handleChange)
    }
    mq.addListener(handleChange)
    return () => mq.removeListener(handleChange)
  }, [])

  const insightsTray = data ? (
    <InsightsTray
      auditSummary={auditSummary}
      largeDatasetInfo={largeDatasetInfo}
      recommendations={recommendations}
      charts={charts}
      aiResult={aiResult}
      onApplyFixes={applyFixes}
      onSelectRecommendation={(chart) => {
        const recommendation = recommendations.find(
          (item) => item.chartKey === chart.metadata.id
        )
        handleRecommendationSelect(chart, recommendation)
      }}
    />
  ) : null

  return (
    <div className="workflow-stage">
      <div className="workflow-step-header">
        <div className="workflow-step-copy">
          <h2>Load Data</h2>
          <p>
            Add a file, paste data, connect a URL or API, or resume a saved
            project. Then review quick health checks below the table.
          </p>
        </div>
        <div className="workflow-step-actions-desktop">{actions}</div>
      </div>
      <DataLoader
        {...dataLoader}
        onHome={() => { clearUrlState(); setShowIntro(true) }}
        data={filteredData || data}
        userData={filteredUserData || dataLoader.userData}
        hydrateFromProject={importProject}
        autoRefreshEnabled={autoRefreshEnabled}
        setAutoRefreshEnabled={setAutoRefreshEnabled}
        autoRefreshInterval={autoRefreshInterval}
        setAutoRefreshInterval={setAutoRefreshInterval}
        lastRefreshedAt={lastRefreshedAt}
        setLastRefreshedAt={setLastRefreshedAt}
        filtersSlot={data && (
          <DataFilters
            data={data}
            dataFilters={dataFilters}
            setDataFilters={setDataFilters}
            filteredRowCount={filteredData?.dataset?.length ?? data.dataset.length}
          />
        )}
        insightsSlot={insightsTray}
        mobileActions={actions}
      />
      {/* Desktop-only: insights rendered below the grid */}
      {!isMobileLayout && insightsTray}
      {/* Mobile actions bar only when no data loaded (sheet handles it when loaded) */}
      {!(isMobileLayout && data) && (
        <div className="workflow-step-actions-mobile">{actions}</div>
      )}
    </div>
  )
}
